module.exports = __webpack_public_path__ + "img/gift.5f9bc114.png";